export const GET_CAMPAIGN_STICKY_COLUMNS = "GET_CAMPAIGN_STICKY_COLUMNS";
export const GET_CAMPAIGN_STICKY_COLUMNS_SUCCESS = "GET_CAMPAIGN_STICKY_COLUMNS_SUCCESS";
export const GET_CAMPAIGN_STICKY_COLUMNS_ERROR = "GET_CAMPAIGN_STICKY_COLUMNS_ERROR";

export const UPDATE_CAMPAIGN_STICKY_COLUMNS = "UPDATE_CAMPAIGN_STICKY_COLUMNS";
export const UPDATE_CAMPAIGN_STICKY_COLUMNS_SUCCESS = "UPDATE_CAMPAIGN_STICKY_COLUMNS_SUCCESS";
export const UPDATE_CAMPAIGN_STICKY_COLUMNS_ERROR = "UPDATE_CAMPAIGN_STICKY_COLUMNS_ERROR";